module.exports = __webpack_public_path__ + "static/media/backicon.e3d6f2c6.svg";